module.exports = __webpack_public_path__ + "img/staff.f9118c60.svg";